module.exports = __webpack_public_path__ + "static/media/v1.5a1df210.mp4";